import type React from 'react';
import { useBlockLockStatus } from '../../hooks/useBlockLockStatus';

export function withBlockLockCheck<P extends { blockId: string }>(Component: React.ComponentType<P>) {
  return function WithBlockLockCheck(props: P) {
    const { blockId } = props;
    const { isLocked } = useBlockLockStatus(blockId);

    return <Component {...props} locked={isLocked} />;
  };
}
